<template>
    <label
        :class="[
            'inline-flex items-center gap-2 leading-none',
            labelBefore ? 'flex-row-reverse' : '',
            disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'
        ]"
    >
        <input
            type="radio"
            class="sr-only"
            :checked="isChecked"
            :disabled="disabled"
            @change="$emit('input', val)"
        />
        <span
            :class="[
                'flex-shrink-0 w-5 h-5 rounded-full border-2 flex items-center justify-center transition-colors',
                isChecked ? colorClass : 'border-theme-disabled'
            ]"
        >
            <span
                class="w-2 h-2 rounded-full bg-white"
                :class="isChecked ? 'opacity-100' : 'opacity-0'"
            ></span>
        </span>
        <span
            v-if="$slots.default"
            class="text-sm text-theme-base leading-normal"
        >
            <slot></slot>
        </span>
    </label>
</template>

<script>
export default {
    name: "CustomRadio",
    props: {
        value: { type: [String, Number, Boolean, Object], default: null },
        val: { type: [String, Number, Boolean, Object], default: null },
        warn: { type: Boolean, default: false },
        success: { type: Boolean, default: false },
        primary: { type: Boolean, default: false },
        danger: { type: Boolean, default: false },
        labelBefore: { type: Boolean, default: false },
        disabled: { type: Boolean, default: false }
    },
    computed: {
        isChecked() {
            return this.value === this.val;
        },
        colorClass() {
            if (this.danger) return "bg-theme-danger border-theme-danger";
            if (this.warn) return "bg-theme-warning border-theme-warning";
            if (this.success) return "bg-theme-success border-theme-success";
            return "bg-theme-primary border-theme-primary";
        }
    }
};
</script>
